import Vue from 'vue';
import { BlockDTO } from '../../../model/BlockDTO';

export async function apartmentLocationHeadingGalleryData(context: Vue, block: BlockDTO) {
	let gallery = await context.$resourceService.fetchImages(block.id, "header-gallery", context.$store.boIdMapping);

	return {
		gallery
	};
}
